import { useEffect, useState } from "react";
import style from "../../../../sass/components/popups/create-shipment-popup.module.scss";
import { useTranslation } from "react-i18next";
import { getSenderDistricts } from "../../../../api/sender-districts/sender-districts";
import GreenSpinner from "../../../../components/loaders/GreenSpinner";
import { SENDER_TOWN_DOES_NOT_HAVE_DISTRICT } from "../../../../data/static-data";

const SenderDistrictInput = ({ state, setState, enabled, senderTownID }) => {
    const { t } = useTranslation();
    const handleChange = (e) => {
        if (!e.target.value) {
            setState("");
            return;
        }
        setState(+e.target.value);
    };

    const [senderDistricts, setSenderDistricts] = useState(null);
    const [isPending, setIsPending] = useState(false);

    useEffect(() => {
        if (!senderTownID) {
            return;
        }

        setIsPending(true);

        (async () => {
            const districts = await getSenderDistricts(senderTownID);
            if (!districts) {
                setState("")
                return;
            }

            setSenderDistricts(districts);
            setIsPending(false);
        })();
    }, [senderTownID, setState]);

    useEffect(() => {
        //if senderDistricts is null, then it means that senderTownID is not set
        if(!senderDistricts ) {
            setState("");
            return;
        }

        //if current sender town contains current sender district, then do nothing
        const district = senderDistricts.find((district) => {
            return +district.id === +state;
        });
        if (district) {
            return;
        }

        if(senderDistricts.length === 0) {
            setState(SENDER_TOWN_DOES_NOT_HAVE_DISTRICT);
            return;
        }

        //if current sender town does not contain current sender district, then set it to first district
        for (let i in senderDistricts) {
            if (+senderDistricts[i]["sender-town-id"] === +senderTownID) {
                setState(+senderDistricts[i].id);
                return;
            }
        }
        
        setState(SENDER_TOWN_DOES_NOT_HAVE_DISTRICT);
    }, [senderDistricts, senderTownID, setState, state]);
    

    return (
        <>
            {senderDistricts?.length > 0 && (
                <>
                    <span className="col-span-12 text-gray-600">
                        {t(
                            "shipments.create_shipment.additional_data.sender_district.name"
                        )}
                    </span>
                    {isPending && <GreenSpinner width="1rem" height="1rem" />}
                    {!isPending && (
                        <select
                            className={`${style.select} col-span-10`}
                            id="sender-district"
                            value={state}
                            onInput={handleChange}
                            disabled={!enabled}
                        >
                            <option value="" disabled selected hidden></option>
                            {senderDistricts?.map((option, index) => (
                                <option
                                    selected={+state === +option.value}
                                    key={index}
                                    value={+option.id}
                                >
                                    {option.name}
                                </option>
                            ))}
                        </select>
                    )}
                </>
            )}
        </>
    );
};

export default SenderDistrictInput;
